import React from "react";
import "./styles.scss";
import { Modal } from "react-bootstrap";

export default class SharingModal extends React.Component {
  handleClose = () => this.setState({ show: false });
  handleShow = () => this.setState({ show: true });
  handleClick = e =>
    this.hocWrapper.current.contains(e.target) && this.handleShow();
  componentDidMount = () =>
    document.body.addEventListener("click", this.handleClick);
  componentWillUnmount = () =>
    document.body.removeEventListener("click", this.handleClick);
  init_state = {
    isLoading: false,
    show: false
  };
  state = this.init_state;
  hocWrapper = React.createRef();
  render() {
    return (
      <>
        <div ref={this.hocWrapper} className="hor_click">
          {this.props.children}
        </div>
        <Modal
          id="fullscreen-box"
          show={this.state.show}
          onHide={this.handleClose}
        >
          <Modal.Body className="fullscreen-box d-flex flex-column">
            <div>
              <p
                className="float-right close-text text-white"
                onClick={this.handleClose}
              >
                Close
              </p>
            </div>
            <div
              className="img media"
              style={{
                backgroundImage: `url(${this.props.imgSrc})`
              }}
            ></div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
